import { render, staticRenderFns } from "./openAccount.vue?vue&type=template&id=2a0fcc06&scoped=true&"
import script from "./openAccount.vue?vue&type=script&lang=js&"
export * from "./openAccount.vue?vue&type=script&lang=js&"
import style0 from "./openAccount.vue?vue&type=style&index=0&id=2a0fcc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0fcc06",
  null
  
)

export default component.exports